<template lang="pug">
.page
  section
    .max-width(v-if="hasToken")
      .row.vertical.center
        .col
          .logo-wrapper
            img.logo(src="../../assets/images/logo-white-text.svg")
        .col
          .form-wrapper
            form(@submit.prevent="submit")
              h1.primary-text Reset Password
              AlertBox(v-if="error", type="danger", :text="error")
              div.form-field(:class="{error: $v.form.password.$error, 'error-required': !$v.form.password.required}")
                label
                  input(placeholder="Password", minlength="8", v-model="$v.form.password.$model", type="password")

              div.form-field.no-margin
                button.button.primary-button(type="submit") Reset

    .max-width(v-else)
      .row.center
        .col
          .information-wrapper
            img.logo(src="../../assets/images/logo-white-text.svg")
            p If you have a valid account, you've got mail. Check your email and click the reset password link.
</template>

<script>

import { required } from 'vuelidate/lib/validators'


export default {
  name: 'ResetPassword',
  beforeMount () {
    if (this.$route.params.token) {
      this.hasToken = true
    }
  },
  data () {
    return {
      error: null,
      hasToken: false,
      form: {
        password: ''
      }
    }
  },
  validations: {
    form: {
      password: {
        required
      },
    }
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('invalid')
      } else {
        this.$store.dispatch('user/resetPassword', {
          token: this.$route.params.token,
          password: this.form.password
        }).then(data => {
          // console.log(data)
          let url = process.env.NODE_ENV === 'development' ? `http://${data.redirectDomain}.feature.watch:3000`: `https://${data.redirectDomain}.feature.watch`
          if(data.isMember){
            url += "/admin"
          }
          window.location.href = url
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.page
  margin 0 auto

.logo-wrapper
  margin-bottom 60px
  text-align center
  img
    max-width 521px
    +for_breakpoint(mobile)
      max-width 100%


.information-wrapper
  padding $spacing-3
  h1
    color #fff
    font-size 22px
    font-weight 500
    margin-bottom $spacing-3
  .logo
    height 36px
    margin-bottom $spacing-3
  p
    color $color-black-lighter
    font-size 18px
    line-height 24px
    &.footer
      //text-align center
      margin-top $spacing-3
      color #fff
      a
        cursor pointer
        margin-left 5px
        text-decoration underline
.form-wrapper
  background-color #fff
  border-radius $border-radius
  margin-left $spacing-3
  padding $spacing-3
  width 412px
  +for_breakpoint(mobile)
    width auto
  h1
    font-size 22px
    text-align center
    margin-bottom 40px
  form
    margin 0 auto
    //max-width 400px

</style>
